import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import PrivateRoute from './containers/PrivateRoute'
import PublicRoute from './containers/PublicRoute'
import LoginPage from './containers/LoginPage/Loadable'
import {
  BOOKABLE_ACTIVITIES,
  BOOKABLE_CREATE,
  BOOKABLE_EDIT,
  HOME,
  LOGIN,
  SUPPLIER,
  SUPPLIER_CREATE,
  USERS,
  TRIPS,
  PAYMENTS,
  ACTIVITY_CREATE,
  BOOKINGS,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  SPREADSHEET_IMPORT,
  OUTREACH,
  GUEST_PROFILE,
  ANALYTICS,
  TRIP_INSPIRATION,
  NUDGES,
} from './routesConstants'
import NotFoundPage from './containers/NotFoundPage/Loadable'
import Home from './containers/Home/Loadable'
import SupplierPage from './containers/SupplierPage/Loadable'
import UsersPage from './containers/UsersPage/Loadable'
import TripsPage from './containers/TripsPage/Loadable'
import PaymentsPage from './containers/PaymentsPage/Loadable'
import BookingsPage from './containers/BookingsPage/Loadable'
import BookableActivityPage from './containers/BookableActivityPage/Loadable'
import { PAGES } from './constants/pages'
import CreateSupplierPage from './containers/SupplierPage/CreateSupplierPage/Loadable'
import CreateBookablePage from './containers/BookableActivityPage/CreateBookablePage/Loadable'
import TripDetailsPage from './containers/TripsPage/TripActivitiesPage/index'
import CreateActivityPage from './containers/TripsPage/CreateTripActivityPage/Loadable'
import CreateTripActivityPage from './containers/TripsPage/CreateTripActivityPage'
import CreateAccommodationPage from './containers/TripsPage/CreateAccommodationPage'
import EditTripPage from './containers/TripsPage/EditTripPage'
import ForgotPasswordPage from './containers/ForgotPasswordPage/Loadable'
import ResetPasswordPage from './containers/ResetPasswordPage/Loadable'
import SpreadsheetImportPage from './containers/SpreadsheetImportPage/Loadable'
import OutreachPage from './containers/OutreachPage/Loadable'
import AnalyticsPage from './containers/AnalyticsPage/Loadable'
import TripInspirationPage from './containers/TripInspirationPage/Loadable'
import NudgesPage from './containers/NudgesPage/Loadable'
import OutreachDetailPage from './containers/OutreachPage/OutreachDetailPage'
import GuestProfilePage from './containers/OutreachPage/GuestProfilePage'
import { Roles } from './constants/enums'

export default function Routes({ user }) {
  return (
    <Switch>
      <PublicRoute user={user} exact path={LOGIN} component={LoginPage} />
      <PublicRoute path={FORGOT_PASSWORD} component={ForgotPasswordPage} />
      <PublicRoute path={RESET_PASSWORD} component={ResetPasswordPage} />

      <PrivateRoute user={user} exact path={HOME} component={Home} title={PAGES.HOME} />
      <PrivateRoute
        user={user}
        exact
        path={SUPPLIER}
        component={SupplierPage}
        title={PAGES.USERS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={USERS}
        component={UsersPage}
        title={PAGES.USERS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={TRIPS}
        component={TripsPage}
        title={PAGES.TRIPS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={PAYMENTS}
        component={PaymentsPage}
        title={PAGES.PAYMENTS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER]}
      />
      <PrivateRoute
        user={user}
        exact
        path={BOOKINGS}
        component={BookingsPage}
        title={PAGES.BOOKINGS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:uuid"
        component={TripDetailsPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:uuid/edit"
        component={EditTripPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:tripId/create-activity"
        component={CreateTripActivityPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:tripId/edit-activity"
        component={CreateTripActivityPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:tripId/create-accommodation"
        component={CreateAccommodationPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/trips/:tripId/edit-accommodation"
        component={CreateAccommodationPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={BOOKABLE_ACTIVITIES}
        component={BookableActivityPage}
        title={PAGES.BOOKABLE_ACTIVITIES}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER]}
      />
      <PrivateRoute
        user={user}
        exact
        path={SUPPLIER_CREATE}
        component={CreateSupplierPage}
        title={PAGES.SUPPLIER}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={BOOKABLE_CREATE}
        component={CreateBookablePage}
        title={PAGES.BOOKABLE}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER]}
      />
      <PrivateRoute
        user={user}
        exact
        path={BOOKABLE_EDIT}
        component={CreateBookablePage}
        title={PAGES.BOOKABLE}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER]}
      />
      <PrivateRoute
        user={user}
        exact
        path={ACTIVITY_CREATE}
        component={CreateActivityPage}
        title={PAGES.ACTIVITIES}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={SPREADSHEET_IMPORT}
        component={SpreadsheetImportPage}
        title="Import Trip"
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={OUTREACH}
        component={OutreachPage}
        title={PAGES.OUTREACH}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={GUEST_PROFILE}
        component={GuestProfilePage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path="/outreach/:uuid"
        component={OutreachDetailPage}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={ANALYTICS}
        component={AnalyticsPage}
        title={PAGES.ANALYTICS}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={TRIP_INSPIRATION}
        component={TripInspirationPage}
        title={PAGES.TRIP_INSPIRATION}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />
      <PrivateRoute
        user={user}
        exact
        path={NUDGES}
        component={NudgesPage}
        title={PAGES.NUDGES}
        allowedRoles={[Roles.ADMIN, Roles.SUPERADMIN]}
      />

      <Route exact path="/">
        <Redirect to={HOME} />
      </Route>

      <Route path="*" component={NotFoundPage} />
    </Switch>
  )
}
